import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "./Product_Images_Modal.css";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faPlay,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

const Product_Images_Modal = ({ images, ...props }) => {
  console.log("Product_Images_Modal", images);

  const swiperRef = useRef(null);

  const [swiper, setSwiper] = useState(null);

  const handleMainSliderClick = (direction) => {
    if (swiper) {
      if (direction === "prev") {
        swiper.slidePrev();
      } else if (direction === "next") {
        swiper.slideNext();
      }
    }
  };

  console.log("images", images);

  return (
    <Modal
      className="Product_Images_Modal"
      // fullscreen={true}
      size="xl"
      {...props}
      centered
    >
      <Modal.Body>
        <div className="container-fulid">
          <div className="products_holder">
            <div className="right_side">
              <div className="swiper_div">
                <div className="testimonial_swiper_wrapper">
                  <Swiper
                    modules={[Navigation]}
                    // navigation={true}
                    centeredSlides={true}
                    spaceBetween={10}
                    loop={true}
                    speed={700}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      575: { slidesPerView: 1.8 },
                      768: { slidesPerView: 1.8 },
                      1200: { slidesPerView: 1.8 },
                    }}
                    className="testimonial_swiper"
                    onSwiper={setSwiper}
                  >
                    {images?.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="testimonial_card">
                          <div className="testimonial_image">
                            <img
                              src={process.env.REACT_APP_IMG_URL + item.image}
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                <div className="silder_btn">
                  <div className="back_btn_holder">
                    <div
                      className="back_btn"
                      onClick={() => handleMainSliderClick("prev")}
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="up_icon" />
                    </div>
                  </div>
                  <div className="back_btn_holder">
                    <div
                      className="back_btn"
                      onClick={() => handleMainSliderClick("next")}
                    >
                      <FontAwesomeIcon
                        icon={faAngleRight}
                        className="down_icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="close_icon_holder">
              <img
                src="/assets/images/icons/close.png"
                className="close_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Product_Images_Modal;
